import { Paper, Text } from '@mantine/core';
import React, { FC } from 'react';

export const MainContentCardTitle: FC<{ className?: string }> = ({
  className,
  children,
}) => {
  return (
    <Text
      className={className}
      sx={(theme) => ({
        fontSize: theme.fontSizes.md,
        fontWeight: 500,
        lineHeight: 1.375,
        color: theme.colors.blue_gray[6],

        [theme.fn.largerThan('xl')]: {
          fontSize: theme.fontSizes.xl,
        },
      })}
    >
      {children}
    </Text>
  );
};

export const CardContainer: FC<{ className?: string }> = ({
  className,
  children,
}) => {
  return (
    <Paper p="xl" radius="md" shadow="sm" className={className}>
      {children}
    </Paper>
  );
};
